//Style
import "./TabelaRelatorioMetas.css"

import leaoImagem from '../../assets/img/leao.svg'
import tigreImagem from '../../assets/img/tigre.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'
import girafaImagem from '../../assets/img/girafa.svg'
import hipopotamoImagem from '../../assets/img/hipopotamo.svg'
import zebraImagem from '../../assets/img/zebra.svg'
import jaguarImagem from '../../assets/img/jaguar.svg'
import vacaLeiteiraImagem from '../../assets/img/vaca.svg'
import suricatoImagem from '../../assets/img/suricato.svg'

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { useEffect, useState, Fragment } from 'react'
import GeneralPaginator from '../GeneralPaginator/GeneralPaginator'
import { logout } from '../../auth'
import { useNavigate } from 'react-router-dom'
import { get } from '../../services/api'
import { json2csv } from 'json-2-csv';

export default function TabelaRelatorioMetas({ metas, setMetas, animais, filtros, isLoaded, page, setPage, numberOfPages, max, authTokenState }) {
    //Control variables
    const [ animalSelecionado, setAnimalSelecionado ] = useState({
        id_animal: 1
    });
    
    //Utils
    const navigate = useNavigate();
    const niveis = ['A', 'B', 'C', 'D', 'E'];
    const imagemMapeada = {
        1: leaoImagem,
        2: tigreImagem,
        3: pinguimImagem,
        4: girafaImagem,
        5: zebraImagem,
        6: hipopotamoImagem,
        7: jaguarImagem,
        8: vacaLeiteiraImagem,
        10: suricatoImagem,
        11: zebraImagem
    };
    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    };
    function formatarValor(val, isFraction=false) {
        if(isFraction)
            return parseFloat(val).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        return parseFloat(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    function selecionarAnimal(animal) {
        setAnimalSelecionado(animal)
    }

    useEffect(() => {
        setAnimalSelecionado(animais[0] || {})
    }, [ animais ]);

    //Actions
    async function downloadCSV() {
        const { data } = await getAllMetasOrByPage(1, true);
        const keyMap = {
            1: 'Leão',
            2: 'Tigre',
            3: 'Pinguim',
            4: 'Girafa',
            5: 'Zebrinha',
            6: 'Hipopótamo',
            7: 'Jaguar',
            8: 'Vaca Leiteira',
            9: 'Campanhas',
            10: 'Suricato',
            11: 'Zebra Velha'
        }

        const formattedData = []
        data.forEach(dataElement => {
            const newDataElement = {}
            newDataElement['Cód Filial'] = dataElement.idfilial - 10000;
            newDataElement['Nome'] = dataElement.filial_nome;
            newDataElement['Cluster'] = dataElement.cluster_nome;
            newDataElement['Região'] = dataElement.regiao_nome;
            newDataElement['Tipo'] = dataElement.tipo;
            newDataElement['Período'] = `${dataElement.mes}-${dataElement.ano}`;
            animais.forEach(animal => {
                const key = keyMap[animal.id_animal]
                const animalData = dataElement.animais.find(({ id_animal }) => Number(id_animal) == animal.id_animal) || {}

                newDataElement[`${key} (Resumo)`] = animal.resumo;
                newDataElement[`${key} (Tipo da meta)`] = animal.tipo_percentual ? 'Percentual' : 'Valor Fixo';
                
                newDataElement[`${key} (Situação)`] = animalData?.desabilitado ? 'Desabilitada' : 'Habilitada';
                newDataElement[`${key} (Meta base)`] = animalData?.valor_base ? formatarValor(animalData.valor_base) : 0;

                animalData?.metas
                    ? animalData.metas.forEach(metaData => {
                        newDataElement[`${key} (Meta-${metaData.nivel})`] = `${formatarValor(metaData.meta, false)}${animal.tipo_percentual ? '%' : ''}`;
                        newDataElement[`${key} (Pontos-${metaData.nivel})`] = `${formatarValor(metaData.pontos, true)}pts`;
                    })
                    : niveis.forEach(nivel => {
                        newDataElement[`${key} (Meta-${nivel})`] = 0;
                        newDataElement[`${key} (Pontos-${nivel})`] = '0pts';
                    })
            })

            formattedData.push(newDataElement)
        })

        try {
            const csv = json2csv(formattedData, { delimiter: { field: ';' } })
            const BOM = new Uint8Array([0xEF,0xBB,0xBF]);
            const blob = new Blob([BOM, csv], { type: 'text/csv;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Excelência_Relatório_Metas.csv');
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error converting JSON to CSV:', error);
        }
    }

    async function getAllMetasOrByPage(newPage, getAllData) {
        try {
            const metasFiltros = {
                id_clusters: filtros.id_clusters,
                id_regioes: filtros.id_regioes,
                idfiliais: filtros.idfiliais, 
                
                id_tipo_metas: filtros.id_tipo_metas, 
                mes: filtros.mes, 
                ano: filtros.ano,

                page: getAllData ? 1 : newPage,
                max: getAllData ? 99999999 : max
            };

            const authToken = localStorage.getItem("adminToken")

            if(authToken == null) {
                logout();
                navigate("/login");
                return;
            }

            const metasResponse = await get(`/admin/metaspaginada?${parseObjectToURLQuery(metasFiltros)}`, null, authToken);

            return metasResponse

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setMetasByPage(newPage, getAllData = false) {
        const metasResponse = await getAllMetasOrByPage(newPage, getAllData)
        setMetas(metasResponse.data);
    }
    
    return (
    <div className={`relatorio-metas-second ${metas === undefined ? 'disabled' : ''} ${!isLoaded ? 'opaque' : ''}`}>
        <div className='header'>
            <div>
                <span>2</span>
                <h1>Consultar Metas</h1>
            </div>
            <button onClick={downloadCSV} className="get-csv" disabled={metas?.length == 0}>
                <FileDownloadIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                Exportar CSV
            </button>
        </div>
        <div className="body">
        {metas?.length > 0 
            ?   <Fragment>   
                <div className='tab-selectors'>
                    {animais.map(animal => 
                        <button key={animal.id_animal}
                            className={`tab-selector ${animal.nome.replace(' ', '-')} ${animal.id_animal == animalSelecionado.id_animal ? 'selected' : ''}`} 
                            onClick={() => selecionarAnimal(animal)}
                        >
                            <img src={imagemMapeada[animal.id_animal]} alt={`Imagem ${animal.nome}`} />
                            <span>{animal.nome}</span>
                        </button>
                    )}
                </div>
                <div className='tab'>
                    <table className="adm-table metas-table">
                        <thead><tr>
                            <th className="idfilial">Cód. Filial</th>
                            <th className="filial">Nome</th>
                            <th className="cluster">Cluster</th>
                            <th className="regiao">Região</th>
                            <th className="tipo">Tipo</th>
                            <th className="situacao">Situação</th>
                            {animalSelecionado.meta_base &&
                                <th className='meta-base'>
                                    <div className="meta-base-wrapper">
                                        Meta base
                                        <span>{animalSelecionado.nome}</span>
                                    </div>
                                </th>
                            }
                            {niveis.map(nivel => 
                                <th key={nivel} colSpan={2} className={`nivel nivel-${nivel}`}>
                                    <div className="nivel-wrapper">
                                        Nível {nivel}
                                        <span>{animalSelecionado.nome} {animalSelecionado.tipo_percentual ? '(Percentual)' : ''}</span>
                                    </div>
                                </th>
                            )}
                        </tr></thead>
                        <tbody>
                            {metas.map(meta => {
                                const animal = meta.animais.find(animal => animal.id_animal == animalSelecionado.id_animal)
                                if(typeof animal === 'undefined'){
                                    return (
                                        <tr key={meta.idfilial} className='adm-table-row'>
                                            <td className="idfilial-td">{meta.idfilial - 10000}</td>
                                            <td>{meta.filial_nome}</td>
                                            <td>{meta.cluster_nome}</td>
                                            <td>{meta.regiao_nome}</td>
                                            <td>{meta.tipo}</td>
                                            <td>----</td>
        
                                            {animalSelecionado?.meta_base && <td className="meta-base-td">0</td>}
                                            
                                            {niveis.map(nivel => <Fragment key={nivel}>
                                                <td className={`meta meta-${nivel}`}>{formatarValor(0)}</td>
                                                <td className={`pontos pontos-${nivel}`}>0pts</td>
                                            </Fragment>)}
                                        </tr>
                                    )
                                }

                                return (
                                    <tr key={meta.idfilial} className='adm-table-row'>
                                        <td className="idfilial-td">{meta.idfilial - 10000}</td>
                                        <td>{meta.filial_nome}</td>
                                        <td>{meta.cluster_nome}</td>
                                        <td>{meta.regiao_nome}</td>
                                        <td>{meta.tipo}</td>
                                        <td className={animal.desabilitado ? 'desabilitada' : 'habilitada'}>
                                            {animal.desabilitado ? 'Desabilitada' : 'Habilitada'}
                                        </td>
    
                                        {animalSelecionado.meta_base && 
                                            <td className="meta-base-td">
                                                {animal.valor_base ? formatarValor(animal.valor_base) : 0}
                                            </td>
                                        }
                                        
                                        {animal.metas.map(metaNivel => <Fragment key={metaNivel.nivel}>
                                            <td className={`meta meta-${metaNivel.nivel}`}>
                                                {animal.tipo_percentual ? `${formatarValor(metaNivel.meta, false)}%` : formatarValor(metaNivel.meta)}
                                            </td>
                                            <td className={`pontos pontos-${metaNivel.nivel}`}>
                                                {formatarValor(metaNivel.pontos, true)}pts
                                            </td>
                                        </Fragment>)}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div> 
                <div className="paginator-wrapper">
                    <GeneralPaginator page={page} setPage={setPage} numberOfPages={numberOfPages} setTableByPage={setMetasByPage} />
                </div>
                </Fragment>
            :   <span className="no-data-found">
                    <WarningAmberIcon style={{width: '50px', height: '50px', marginBottom: '5px'}} />
                    <span>Não foi encontrado nenhuma meta com os filtros utilizados</span>
                </span>
        }
        </div>
    </div>
    )
}